type DiseasesListProps = {
  diseases: { code: string; description: string }[]
}

const DiseasesList = ({ diseases }: DiseasesListProps) => {
  return diseases.map(({ code, description }) => (
    <p className="typography-body-l" key={code}>
      {code} {description}
    </p>
  ))
}

export default DiseasesList
